import React, { useState, useEffect } from "react";
import useAxios from "axios-hooks";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import MainRouter from "../../router/MainRouter";
import Header from "../header/Header";
import SeoBlock from "../../components/seo_block/SeoBlock";
import { CookieNotification } from "../cookie-notification";
import Api from "../../api";
import { ProjectSingle } from "../../pages";
import { Button, FullModal, CallbackForm } from "../";

import "../../assets/styles/main.scss";

const ProjectPage = ({ contact }) => {
  const location = useLocation();

  useEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Header contact={contact} />
      <main>
        <ProjectSingle contact={contact} />
      </main>
    </>
  );
};

const App = () => {
  const isSatging =
    window.location.origin === "http://xn--80agebpdgcqigcmoh1ah9m.xn--p1ai";
  const subdomain =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? "krasnoyarsk"
      : window.location.hostname.split(".")[0];
  const [currentCity, setCurrentCity] = useState(
    subdomain.length > 0 &&
      subdomain !== "staging" &&
      subdomain !== "proektmarketing"
      ? subdomain
      : "russia"
  );
  let [{ data }] = useAxios({ url: Api.contact.replace(":slug", currentCity) });
  const contact = data && data.contact;
  const seo = data ? data.seo : {};
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("customer");
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isCookieVisible, setCookieVisible] = useState(null);

  const closeModal = () => {
    setIsOpenModal(false);
  };

  const openModal = () => {
    setIsOpenModal(true);
  };

  useEffect(function addCityToPathname() {
    window.history.scrollRestoration = "manual";

    /*if (contact && contact.slug.length > 0 && !pathname.includes(contact.slug) && pathname !== "/" && !(window.location.host.split('.').length > 2)) {
      navigate({
        pathname: `/${contact.slug}${pathname}`,
        search: customerId ? `?customer=${customerId}` : ""
      }, {
        replace: true
      });
    }*/
  });

  return (
    <div className="app">
      <SeoBlock data={seo} contact={contact} />
      {isSatging ? <div className="staging"></div> : ""}
      <Button
        isAccent
        className={`${
          isCookieVisible ? "callback-button" : "callback-button--shifted"
        }`}
        // disabled
        onClick={() => {
          openModal();
        }}
      >
        Начать проект
      </Button>

      {isOpenModal && (
        <FullModal close={closeModal}>
          <CallbackForm className="callback-section" onSuccess={closeModal} />
        </FullModal>
      )}

      <Routes>
        <Route
          path="/projects/:slug"
          exact
          element={<ProjectPage contact={contact} />}
        />
        <Route
          path="/projects/:slug/edit"
          exact
          element={<ProjectPage contact={contact} />}
        />
        <Route
          path="*"
          element={
            <MainRouter setCurrentCity={setCurrentCity} contact={contact} />
          }
        />
      </Routes>

      <CookieNotification
        onShowChange={(state) => {
          setCookieVisible(state);
        }}
      />
    </div>
  );
};

export default App;
